// import { database } from '../includes/firebase';
import { Project } from '../models/project';
import { Observable } from '../shared/observable';

export const apiProjects$ = new Observable(
  [] as Project[],
  (obs: Observable) => {

    fetch('/data/db.json')
      // database
      //   .ref("projects")
      //   .get()
      .then(res => res.json())
      .then(val => {
        const projects = (val.projects ?? []) as Project[];

        obs.next(
          projects
            .sort((a, b) => a.id < b.id ? 1 : -1)
        );
      })
  }
);
